import { useContext } from "react";
import { Page } from "components";
import { appUserContext } from "helpers/services";
import { Filters, Toolbar, Results } from "./components";
import { serialNumbersContext } from "./SerialNumbersProvider";

let SerialNumbers = () => {

    let { currentUser } = useContext(appUserContext);
    let { isLoading } = useContext(serialNumbersContext);

    return (
        <Page
            useHeader={true}
            title="Serial Numbers"
            isLoading={isLoading}
            addNewUrl={currentUser?.isSerialNumbersEditor === true ? "/serialNumber/addnew" : undefined}
        >
            <Filters />
            <Toolbar />
            <Results />
        </Page>
    )
}

export default SerialNumbers;